import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import {
	InputWithButton,
	InputWithButtonProps,
} from '../InputWithButton/InputWithButton';

export interface SearchBoxProps extends InputWithButtonProps {
	title: string;
	subtitle: string;
	alternative?: boolean;
	orientation?: 'vertical' | 'horizontal';
}

export const SearchBox = ({
	isReadonly,
	title,
	subtitle,
	alternative = false,
	orientation = 'vertical',
	sx = [],
	ref,
	...buttonProps
}: SearchBoxProps): React.JSX.Element => (
	<Paper
		variant={alternative ? 'flatGrey' : 'outlined'}
		sx={[
			{
				p: 2,
			},
			orientation === 'horizontal'
				? {
						display: 'flex',
						alignItems: 'center',
						'& > .SearchBoxTitle-root': {
							flex: 2,
						},
						'& > .input-with-button__root': {
							flex: 5,
						},
					}
				: null,
			...(Array.isArray(sx) ? sx : [sx]),
		]}>
		<Box className="SearchBoxTitle-root">
			<Typography
				variant={alternative ? 'subtitle1' : 'h3'}
				sx={{
					pt: 0.5,
				}}>
				{title}
			</Typography>
			<Typography
				variant="body2"
				sx={{
					pt: 1,
					pb: 2,
				}}>
				{subtitle}
			</Typography>
		</Box>
		<InputWithButton isReadonly={isReadonly} ref={ref} {...buttonProps} />
	</Paper>
);
